<script>
	import BillingDropdownBody from "./DropdownBody";
	import BaseStylableTextarea from "../UI/BaseStylableTextarea";
	import { mapState, mapGetters } from "vuex";

	export default {
		components: { BillingDropdownBody, BaseStylableTextarea },
		props: {
			dataAsProps: {
				type: Object,
				required: false,
				default: undefined
			},
			sectionId: {
				type: Number,
				required: true
			},
			index: {
				type: Number,
				required: true
			}
		},
		data() {
			return {
				comment: "",
				...this.dataAsProps
			};
		},
		computed: {
			...mapGetters(["enabledHeaders"]),
			...mapState({
				dynamicColspan: state => state.billing.dynamicColspan,
				isEditable: state => state.home.isEditable,
			})
		},
		watch: {
			$data: {
				handler: function (newValue) {
					this.$emit("update:dataAsProps", newValue);
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			// remove the current line
			// need rework
			/**
			 * bubble up the request to the parent for this component to be removed at the specified index
			 * @param {{String , Number}} parameter recivied parameter of the trigger event
			 */
			remove({ sectionId, index }) {
				this.$emit("event-remove", { sectionId, index });

				// // Destroy the Vue listeners, etc
				// this.$destroy();

				// // Remove the element from the DOM
				// this.$el.parentNode.removeChild(this.$el);
			},
			/**
			 * bubble up the request to the parent for this component to be duplicated
			 * @param {Number} position index to add the new component at
			 */
			duplicate(position) {
				this.$emit("event-append", {
					component: "comment",
					data: this.$data,
					sectionId: this.sectionId,
					position
				});
			},
			/**
			 * bubble up the request to the parent for a new line of specified component at the specified index
			 * @param {{String , Number}} parameter recivied parameter of the trigger event
			 */
			append({ component, position }) {
				this.$emit("event-append", {
					component,
					sectionId: this.sectionId,
					position
				});
			}
		}
	};
</script>

<template>
	<b-td
		:colspan="dynamicColspan"
		class="billing__cell"
		tabindex="1"
	>
		<div v-if="isEditable">
			<BillingDropdownBody
				v-if="enabledHeaders.line_number"
				:section-id="sectionId"
				:index="index"
				:no-accounts="true"
				style="top: 0; left: 35px; position: absolute;"
				@event-append="append"
				@event-duplicate="duplicate"
				@event-remove="remove"
			/>
			<BillingDropdownBody
				v-else
				:section-id="sectionId"
				:index="index"
				:no-accounts="true"
				style="top: 0; left: 349px; position: absolute"
				@event-append="append"
				@event-duplicate="duplicate"
				@event-remove="remove"
			/>
		</div>

		<BaseStylableTextarea
			v-model.lazy="comment"
			:autofocus="true"
			:placeholder="$t('Commentaire...')"
			class="billing__input billing__input--fullWidth"
		/>
	</b-td>
</template>
